import React from 'react';

import useStyles from './styles';

import { Period as PeriodType } from '../../types';

interface Props {
    value: `${PeriodType}`;
    onChange?: (period: PeriodType) => void;
    className?: string;
}

const Period: React.FC<Props> = ({ value, onChange, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <span
                className={cx(classes.button, { [classes._active]: value === PeriodType.MONTHLY })}
                onClick={() => onChange?.(PeriodType.MONTHLY)}
            >
                {'Monthly'}
            </span>
            <span
                className={cx(classes.button, { [classes._active]: value === PeriodType.ANNUALLY })}
                onClick={() => onChange?.(PeriodType.ANNUALLY)}
            >
                {'Annually'}
            </span>
        </div>
    );
};

export default Period;
